var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadMapGenerated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-240 -286.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3799",
    "data-name": "Ellipse 3799",
    transform: "translate(240 286.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(246.359 289.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M247.448,293.38a.448.448,0,0,1-.317-.766l4.484-4.484a.449.449,0,1,1,.635.635l-4.484,4.484A.45.45,0,0,1,247.448,293.38Z",
    transform: "translate(-247 -288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M256.932,293.38a.45.45,0,0,1-.317-.131l-4.484-4.484a.449.449,0,1,1,.635-.635l4.484,4.484a.448.448,0,0,1-.317.766Z",
    transform: "translate(-247.516 -288)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M257.432,311.4H245.347c-.732,0-.237-.9,0-.9h12.084C257.675,310.5,258.173,311.4,257.432,311.4Z",
    transform: "translate(-0.108 -7.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M252.448,299.087a.449.449,0,0,1-.448-.448v-10.19a.448.448,0,0,1,.9,0v10.19A.449.449,0,0,1,252.448,299.087Z",
    transform: "translate(-1.157 1.924)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadMapGenerated);
export default __webpack_public_path__ + "static/media/uploadMapGenerated.d0adabe3c1dbe286a1bb3c6c82db9100.svg";
export { ForwardRef as ReactComponent };